function SidebarContainerController() {
    const ctrl = this;
}

angular
    .module('sidebar.module')
    .controller('SidebarContainerController', SidebarContainerController);